import { render, staticRenderFns } from "./profit-sharing-record.vue?vue&type=template&id=3ae0504e&scoped=true&"
import script from "./profit-sharing-record.vue?vue&type=script&lang=js&"
export * from "./profit-sharing-record.vue?vue&type=script&lang=js&"
import style0 from "./profit-sharing-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./profit-sharing-record.vue?vue&type=style&index=1&id=3ae0504e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae0504e",
  null
  
)

export default component.exports